import { DocumentStatus } from '@synergy/models';
import { FormattedMessage } from 'react-intl';

import { InvoiceSteps } from '../models/invoice-steps';
import { PoolStepperStep } from '../../../../common/components/new-stepper/pool-stepper';

export const getActionStep = (status: DocumentStatus, isCredit: boolean): PoolStepperStep => {
    switch (status) {
        case DocumentStatus.Created: {
            return {
                label: (
                    <FormattedMessage
                        id="app.menu.action.complete"
                        values={
                            isCredit
                                ? { value: <FormattedMessage id="app.document.credit" /> }
                                : { value: <FormattedMessage id="app.common.invoice" /> }
                        }
                    />
                ),
                type: 'action',
                stepId: InvoiceSteps.Action,
            };
        }
        case DocumentStatus.Completed: {
            return {
                label: (
                    <FormattedMessage
                        id="app.menu.action.cancel"
                        values={
                            isCredit
                                ? { value: <FormattedMessage id="app.document.credit" /> }
                                : { value: <FormattedMessage id="app.common.invoice" /> }
                        }
                    />
                ),
                type: 'actionError',
                stepId: InvoiceSteps.Action,
            };
        }
        case DocumentStatus.Canceled: {
            return {
                label: (
                    <FormattedMessage
                        id="app.menu.action.cancel"
                        values={{ value: <FormattedMessage id="app.common.invoice" /> }}
                    />
                ),
                type: 'action',
                stepId: InvoiceSteps.Action,
            };
        }

        default: {
            return {
                label: (
                    <FormattedMessage
                        id="app.menu.action.complete"
                        values={{ value: <FormattedMessage id="app.common.invoice" /> }}
                    />
                ),
                type: 'action',
                stepId: InvoiceSteps.Action,
            };
        }
    }
};
